
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import BottomNavigation from '../../../components/feature/BottomNavigation';
import ProductCard from '../../../components/feature/ProductCard';
import { featuredProducts } from '../../../mocks/products';

export default function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState<any>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [showAddedMessage, setShowAddedMessage] = useState(false);
  const [selectedTab, setSelectedTab] = useState('description');

  useEffect(() => {
    // البحث عن المنتج
    const foundProduct = featuredProducts.find(p => p.id === parseInt(id || '0'));
    if (foundProduct) {
      setProduct({
        ...foundProduct,
        images: [foundProduct.image, foundProduct.image, foundProduct.image], // صور متعددة للعرض
        description: 'قهوة فاخرة مختارة بعناية من أجود أنواع البن العربي الأصيل. تتميز بطعمها الغني ونكهتها المميزة التي تأسر الحواس. محمصة بطريقة تقليدية للحصول على أفضل طعم ورائحة.',
        specifications: [
          'النوع: قهوة عربية 100%',
          'المنشأ: المملكة العربية السعودية',
          'درجة التحميص: متوسطة',
          'الوزن: 250 جرام',
          'تاريخ الانتهاء: 12 شهر من تاريخ الإنتاج'
        ],
        ingredients: ['بن عربي طبيعي 100%', 'خالي من المواد الحافظة', 'خالي من الإضافات الصناعية']
      });
    }

    // تحميل السلة
    const savedCart = localStorage.getItem('cartItems');
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  }, [id]);

  const handleAddToCart = () => {
    if (!product) return;

    const existingItem = cartItems.find(item => item.id === product.id);
    let updatedCart;
    
    if (existingItem) {
      updatedCart = cartItems.map(item => 
        item.id === product.id 
          ? { ...item, quantity: item.quantity + quantity }
          : item
      );
    } else {
      updatedCart = [...cartItems, { ...product, quantity }];
    }
    
    setCartItems(updatedCart);
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));

    // إظهار رسالة التأكيد
    setShowAddedMessage(true);
    setTimeout(() => setShowAddedMessage(false), 3000);
  };

  const handleBuyNow = () => {
    handleAddToCart();
    setTimeout(() => navigate('/cart'), 500);
  };

  const getTotalCartItems = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  const relatedProducts = featuredProducts.filter(p => 
    p.id !== product?.id && p.category === product?.category
  ).slice(0, 4);

  if (!product) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center">
        <div className="text-center">
          <i className="ri-error-warning-line text-4xl text-[#777777] mb-4"></i>
          <h2 className="text-xl font-bold text-[#333333] mb-4">المنتج غير موجود</h2>
          <button
            onClick={() => navigate('/')}
            className="bg-[#D4AF37] text-white px-6 py-3 rounded-lg"
          >
            العودة للرئيسية
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header cartItemsCount={getTotalCartItems()} />
      
      {/* رسالة تأكيد الإضافة */}
      {showAddedMessage && (
        <div className="fixed top-20 left-4 right-4 z-50 bg-green-500 text-white p-4 rounded-lg shadow-lg">
          <div className="flex items-center" dir="rtl">
            <i className="ri-check-line text-xl ml-2"></i>
            <span className="font-medium">تم إضافة المنتج إلى السلة بنجاح</span>
          </div>
        </div>
      )}
      
      <main className="pt-16 pb-32">
        {/* Back Button */}
        <div className="px-4 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-[#333333] hover:text-[#D4AF37] transition-colors"
            dir="rtl"
          >
            <i className="ri-arrow-right-line text-xl ml-2"></i>
            <span>العودة</span>
          </button>
        </div>

        {/* Product Images */}
        <div className="relative mb-6">
          <div className="h-80 overflow-hidden">
            <img
              src={product.images[currentImageIndex]}
              alt={product.name}
              className="w-full h-full object-cover object-top"
            />
          </div>
          
          {product.originalPrice && (
            <div className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              خصم {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}%
            </div>
          )}
          
          {/* Image Indicators */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {product.images.map((_: any, index: number) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors duration-200 ${
                  index === currentImageIndex ? 'bg-[#D4AF37]' : 'bg-white/50'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="px-4 mb-6">
          <h1 className="text-xl font-bold text-[#333333] mb-3 text-right" dir="rtl">
            {product.name}
          </h1>
          
          <div className="flex items-center justify-between mb-4" dir="rtl">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className={`ri-star-${i < product.rating ? 'fill' : 'line'} text-lg ${
                    i < product.rating ? 'text-[#D4AF37]' : 'text-gray-300'
                  }`}
                />
              ))}
              <span className="text-sm text-[#777777] mr-2">({product.rating}) • 127 تقييم</span>
            </div>
          </div>
          
          <div className="flex items-center gap-3 mb-6" dir="rtl">
            <span className="text-2xl font-bold text-[#4B2E05]">
              {product.price} ر.س
            </span>
            {product.originalPrice && (
              <span className="text-lg text-[#777777] line-through">
                {product.originalPrice} ر.س
              </span>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div className="px-4 mb-6">
          <div className="flex border-b border-gray-200" dir="rtl">
            <button
              onClick={() => setSelectedTab('description')}
              className={`flex-1 py-3 text-center font-medium transition-colors ${
                selectedTab === 'description'
                  ? 'text-[#D4AF37] border-b-2 border-[#D4AF37]'
                  : 'text-[#777777]'
              }`}
            >
              الوصف
            </button>
            <button
              onClick={() => setSelectedTab('specifications')}
              className={`flex-1 py-3 text-center font-medium transition-colors ${
                selectedTab === 'specifications'
                  ? 'text-[#D4AF37] border-b-2 border-[#D4AF37]'
                  : 'text-[#777777]'
              }`}
            >
              المواصفات
            </button>
            <button
              onClick={() => setSelectedTab('ingredients')}
              className={`flex-1 py-3 text-center font-medium transition-colors ${
                selectedTab === 'ingredients'
                  ? 'text-[#D4AF37] border-b-2 border-[#D4AF37]'
                  : 'text-[#777777]'
              }`}
            >
              المكونات
            </button>
          </div>
          
          <div className="py-4">
            {selectedTab === 'description' && (
              <p className="text-[#777777] leading-relaxed text-right" dir="rtl">
                {product.description}
              </p>
            )}
            
            {selectedTab === 'specifications' && (
              <ul className="space-y-2" dir="rtl">
                {product.specifications.map((spec: string, index: number) => (
                  <li key={index} className="flex items-center text-[#777777]">
                    <i className="ri-check-line text-[#D4AF37] ml-2"></i>
                    {spec}
                  </li>
                ))}
              </ul>
            )}
            
            {selectedTab === 'ingredients' && (
              <ul className="space-y-2" dir="rtl">
                {product.ingredients.map((ingredient: string, index: number) => (
                  <li key={index} className="flex items-center text-[#777777]">
                    <i className="ri-leaf-line text-green-500 ml-2"></i>
                    {ingredient}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Quantity Selector */}
        <div className="px-4 mb-6">
          <div className="bg-white rounded-xl p-4 shadow-md">
            <div className="flex items-center justify-between" dir="rtl">
              <span className="font-medium text-[#333333]">الكمية</span>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center"
                >
                  <i className="ri-subtract-line text-[#D4AF37]"></i>
                </button>
                
                <span className="font-bold text-lg text-[#333333] min-w-[3rem] text-center">
                  {quantity}
                </span>
                
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center"
                >
                  <i className="ri-add-line text-[#D4AF37]"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Related Products */}
        {relatedProducts.length > 0 && (
          <div className="px-4 mb-6">
            <h3 className="text-lg font-bold text-[#333333] mb-4 text-right" dir="rtl">
              منتجات مشابهة
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {relatedProducts.map((relatedProduct) => (
                <ProductCard
                  key={relatedProduct.id}
                  product={relatedProduct}
                  onAddToCart={(product) => {
                    const existingItem = cartItems.find(item => item.id === product.id);
                    let updatedCart;
                    
                    if (existingItem) {
                      updatedCart = cartItems.map(item => 
                        item.id === product.id 
                          ? { ...item, quantity: item.quantity + 1 }
                          : item
                      );
                    } else {
                      updatedCart = [...cartItems, { ...product, quantity: 1 }];
                    }
                    
                    setCartItems(updatedCart);
                    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
                  }}
                  onClick={() => navigate(`/product/${relatedProduct.id}`)}
                />
              ))}
            </div>
          </div>
        )}
      </main>

      {/* Fixed Bottom Actions */}
      <div className="fixed bottom-16 left-0 right-0 bg-white border-t border-gray-200 p-4">
        <div className="flex gap-3" dir="rtl">
          <button
            onClick={handleAddToCart}
            className="flex-1 bg-white border-2 border-[#D4AF37] text-[#D4AF37] py-3 rounded-lg font-bold hover:bg-[#D4AF37]/5 transition-colors"
          >
            أضف إلى السلة
          </button>
          <button
            onClick={handleBuyNow}
            className="flex-1 bg-[#D4AF37] text-white py-3 rounded-lg font-bold hover:bg-[#B8941F] transition-colors"
          >
            اشتري الآن
          </button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
